<template lang="pug">
    div
        iframe.htmlPreviewFrame(:srcdoc="htmlPreviewResult")
</template>
<script>
import { queryParamsFieldsCompletion, generateHtmlPreview } from "@/libs/rcmTableFieldsFunction";

export default {
    props: ["formItem", "formData", "value"],
    components: {},
    watch: {},
    data() {
        return {
            queryParamsFields: this.formItem.queryParamsFields || [],
            htmlPreviewResult: this.formData.htmlPreview || "",
        };
    },
    methods: {
        generateHtmlPreview() {
            this.htmlPreviewResult = generateHtmlPreview({
                htmlPageRaw: this.formData.htmlPageRaw,
                ridPosition: this.formData.ridPosition,
                ridColor: this.formData.ridColor,
            });
        },
    },
    mounted() {
        this.generateHtmlPreview();
    },
    created() {
        this.queryParamsFields = queryParamsFieldsCompletion(this.queryParamsFields);

        // 監聽需要注意的欄位
        this.queryParamsFields.forEach((field) => {
            let { fieldName, queryIf } = field;
            this.$watch(
                function () {
                    return this.formData[fieldName];
                },
                function (newVal, oldVal) {
                    if (queryIf(newVal)) {
                        this.generateHtmlPreview();
                    }
                },
                { deep: true }
            );
        });
    },
    computed: {},
};
</script>
<style>
.htmlPreviewFrame {
    height: 360px;
    width: 100%;
    border: none;
}
</style>



// WEBPACK FOOTER //
// src/components/rcmTableFormItems/HtmlPreview.vue